module.exports = __webpack_public_path__ + "static/media/temp_17.fedb1eba.jpg";